<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-grid" *ngIf="!isloader && !isError">
    <div class="vehicle-profile-header info-icon-align position-relative">
        <div>
            <div>{{widgetData?.title}}</div>
            <div class="ft-12" *ngIf="deviceDetail?.deviceId==entityDetails?.device?._id">{{sourceTimestamp}}</div>
        </div>
        <div class="am-hover-controller position-relative"><img alt="Info"
                src="../../../../assets/images/info-circle.svg">
        </div>
        <!--the hover-pop-->

        <div class="will-appear-on-hover bg-for-popout gap20" id="hover-pop-dover1">

            <div class="d-flex align-items-center gap20 pop-delivery">
                <div><img alt="Battery" src="../../../../assets/images/batteryPercent.svg"></div>
                <div>
                    <div class="active">
                        <div class="condition condition-green">Charged</div>
                        <div class="condition-value">Above 50%</div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center gap20 pop-delivery">
                <div><img alt="Battery" src="../../../../assets/images/low-battery.svg"></div>
                <div>
                    <div class="exhausted">
                        <div class="condition condition-yellow">To be charged</div>
                        <div class="condition-value">Below 50%</div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center gap20 pop-delivery">
                <div><img alt="Battery" src="../../../../assets/images/very-low-battery.svg"></div>
                <div>
                    <div class="exhausted">
                        <div class="condition condition-red">Battery Low</div>
                        <div class="condition-value">Below 20%</div>
                    </div>
                </div>
            </div>
        </div>
        <!--hover pop ends-->

    </div>


    <div class="d-flex flex-column">
        <div class="device-font-class mb-2"> Sensor ID :
            <span *ngIf="entityDetails?.device?.deviceName">{{entityDetails?.device?.deviceName}}</span>
            <span *ngIf="!entityDetails?.device?.deviceName">NA</span>
        </div>
        <div class="device-font-class">Sensor Condition :
            <span *ngIf="deviceDetail?.condition && deviceDetail?.deviceId==entityDetails?.device?._id"
                class="sensor-cond-style" [ngClass]="{'sensor-cond-style-red': +deviceDetail?.attributeValue<=20,
                'sensor-cond-style-yellow': +deviceDetail?.attributeValue<50 && +deviceDetail?.attributeValue>20, 
                    'sensor-cond-style-green': +deviceDetail?.attributeValue>=50}">{{deviceDetail?.condition}}</span>
            <span *ngIf="!deviceDetail?.condition || deviceDetail?.deviceId!=entityDetails?.device?._id">NA</span>
        </div>
    </div>
    <div class="d-flex align-items-end">
        <div>
            <div class="mt-auto d-flex align-items-end"><img src="../../../../assets/images/batteryPercent.svg"
                    class="battery-size-per"
                    *ngIf="deviceDetail?.attributeValue>=50 && deviceDetail?.deviceId==entityDetails?.device?._id">
                <img src="../../../../assets/images/low-battery.svg" class="battery-size-per"
                    *ngIf="deviceDetail?.attributeValue<50 && deviceDetail?.attributeValue>20 && deviceDetail?.deviceId==entityDetails?.device?._id">
                <img src="../../../../assets/images/very-low-battery.svg"
                    *ngIf="deviceDetail?.attributeValue<=20 && deviceDetail?.deviceId==entityDetails?.device?._id"
                    class="battery-size-per">
                <span *ngIf="deviceDetail?.attributeValue && deviceDetail?.deviceId==entityDetails?.device?._id"
                    class="battery-font">{{deviceDetail?.attributeValue}}</span>
                <span *ngIf="!deviceDetail?.attributeValue || deviceDetail?.deviceId!=entityDetails?.device?._id"
                    class="battery-font">NA</span>%
            </div>
            <div class="device-label">Battery Level</div>
        </div>
        <div class="ml-auto">
            <div mat-button (click)="deviceSwap();$event.stopPropagation();"
                class="d-grid m-0 px-0 justify-content-center w-100"><img src="../../assets/images/dover-map-device.svg"
                    class="d-grid h-27 cursor hover-color" title="Change Device" alt="Change Device"></div>
            <div class="device-label">Change Device</div>
        </div>
    </div>
</div>